import PageHeader from "../components/PageHeader";
import LiveClass from "../components/LiveClasses"

export default function LiveClasses() {
    const getTeacherId = sessionStorage.getItem('id')
    return (
        <>
            <PageHeader
                title="Live Classes"
                breadcrumbs={[
                    { label: "Dashboard", path: "/institute-dashboard" },
                    { label: "Live Classes", active: true },
                ]}
            />
            <LiveClass batchId={1} courseId={115} teacherId={parseInt(getTeacherId)} teacherName="Yogesh Singh" meetCode="cfj-nrai-khv"/>
        </>
    );
}
